import React from "react"
import ReactDOM from "react-dom"
import ReactGA from "react-ga"
import {Provider} from "react-redux"
// tslint:disable-next-line:no-submodule-imports
import "react-table/react-table.css"
import "url-search-params-polyfill"
import {authStore} from "./app/common/authentication/AuthStore"
import {productStore} from "./app/common/products/ProductStore"
import {App} from "./components/App/App"
import store from "./redux/store"
import "./styles/index.scss"
import {EnvUtils} from "./util/EnvUtils"

if (EnvUtils.isProd()) {
    ReactGA.initialize("UA-82755982-25")
} else {
    ReactGA.initialize("UA-82755982-26")
}

authStore.loadAuth()
productStore.loadLoginProduct()

ReactDOM.render(
    <Provider store={store}>
        <App/>
    </Provider>,
    document.getElementById("root") as HTMLElement
)
